import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { adminAgentsAPI } from '../../../../services/api';

export default function SettingsNode({ selected }) {
  const { agentName } = useParams();
  const [agent, setAgent] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    adminAgentsAPI.listAgents().then((agents) => {
      const found = (agents || []).find((a) => a.name === agentName);
      if (mountedRef.current) setAgent(found || null);
    }).catch(() => {});
    return () => { mountedRef.current = false; };
  }, [agentName]);

  return (
    <Box sx={{ border: `2px solid ${selected ? '#b07ae0' : '#8a5aaa'}`, borderRadius: 2, minWidth: 160, bgcolor: 'background.paper', boxShadow: selected ? '0 0 0 3px rgba(176,122,224,0.15)' : 1, overflow: 'hidden' }}>
      <Box sx={{ px: 1.5, py: 0.75, bgcolor: '#2a1a3a', display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography sx={{ color: '#b07ae0', fontSize: 14 }}>⚙</Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#c0a0f0', fontSize: 11 }}>Settings</Typography>
      </Box>
      <Box sx={{ px: 1.5, py: 0.75 }}>
        {!agent && <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 9, fontStyle: 'italic' }}>Loading…</Typography>}
        {agent?.model_name && <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', fontSize: 9 }}>Model: {agent.model_name}</Typography>}
        {agent && agent.allow_multi_user !== undefined && <Typography variant="caption" sx={{ display: 'block', color: agent.allow_multi_user ? 'success.main' : 'text.disabled', fontSize: 9 }}>Multi-user: {agent.allow_multi_user ? 'On' : 'Off'}</Typography>}
      </Box>
    </Box>
  );
}
